import { render, staticRenderFns } from "./FeatureCategoryManager.vue?vue&type=template&id=5db13661&scoped=true"
import script from "./FeatureCategoryManager.vue?vue&type=script&lang=js"
export * from "./FeatureCategoryManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db13661",
  null
  
)

export default component.exports